(function () {
  const FAQ_ITEMS = [
    {
      main_category: 'Order & Payment',
      sub_category: 'Order Issues & Adjustments',
      question: 'Why am I unable to place an order?',
      answer:
        '<p>If you encounter any issues checking out your order, you can try using a different payment method. Also, please consider providing our customer care team with any error messages or notifications you receive during the payment process, such as screenshots or recordings. And kindly contact our customer service to get more help. Our representative will assist you in resolving this matter.</p>'
    },
    {
      main_category: 'Order & Payment',
      sub_category: 'Order Issues & Adjustments',
      question: 'How do I use a discount code or gift card while placing an order?',
      answer:
        '<p>1. Add the wig you want to the shopping cart or click the Buy Now button to reach the checkout page.<br><br>2. Complete your delivery information and payment method, and enter your coupon code and gift card code in the order information at the bottom.<br><br>3. Please note that coupons cannot be used again for flash sale items, but gift cards can be used at any time.</p>'
    },
    {
      main_category: 'Order & Payment',
      sub_category: 'Payment Issues',
      question: 'Do I need to pay sales tax for my order?',
      answer:
        "<p>Any applicable sales tax is automatically calculated at checkout based on your shipping address. You'll see the amount clearly at checkout before you complete your purchase, and you won't need to pay any additional sales tax when your order is delivered.</p>"
    },
    {
      main_category: 'Order & Payment',
      sub_category: 'Payment Issues',
      question: 'Why is sales tax added to my order?',
      answer:
        '<p>Sales tax is required by law in the United States and varies by state and locality. The tax ensures compliance with local tax regulations and is collected at checkout for your convenience.</p>'
    },
    {
      main_category: 'Order & Payment',
      sub_category: 'Order Issues & Adjustments',
      question: 'How can I cancel or change my order?',
      answer:
        '<p>Order modifications or cancellations must be requested within 1 hour of placing the order. After 1 hour, the order cannot be canceled or changed. In this case, we recommend receiving the package first and then contacting us for further assistance.</p><p>If your order is still within the 1-hour window, please reach out to our customer service directly for modifications or cancellations.</p>'
    },
    {
      main_category: 'Order & Payment',
      sub_category: 'Payment Issues',
      question: 'What payment methods do you accept?',
      answer:
        "<p>We accept various payment methods including Credit/Debit Card, PayPal, Apple Pay, Google Pay, After Pay, Klarna. If you're experiencing payment issues, please ensure your payment method has sufficient funds and is authorized for online transactions.</p>"
    },
    {
      main_category: 'Order & Payment',
      sub_category: 'Payment Issues',
      question: 'How can I use a credit or debit card to pay for my order?',
      answer:
        "<p>To pay with a Credit/Debit Card on Blovo Hair, you can select from the available credit cards listed. It's important to note that Blovo Hair does not collect your credit/debit card number or personal information during the payment process. For any transaction-related queries, you should contact your card-issuing bank.</p>"
    },
    {
      main_category: 'Order & Payment',
      sub_category: 'Payment Issues',
      question: 'How can I split my payments?',
      answer:
        '<p>Afterpay, Klarna, and Paypal allow you to split your purchases into 4 payments. It enables you to shop conveniently and responsibly without impacting your credit.</p>'
    },
    {
      main_category: 'Order & Payment',
      sub_category: 'Payment Issues',
      question: 'Is my payment information secure?',
      answer:
        '<p>Yes, we use industry-standard encryption and security measures to protect your payment information. All transactions are processed through secure, PCI-compliant payment gateways.</p>'
    },
    {
      main_category: 'Order & Payment',
      sub_category: 'Payment Issues',
      question: 'Do I need to pay for the tax or duty fee?',
      answer:
        "<p>Any applicable sales tax is automatically calculated at checkout based on your shipping address. You'll see the amount clearly at checkout before you complete your purchase.</p>"
    },
    {
      main_category: 'Track & Shipping',
      sub_category: 'Shipping & Delivery',
      question: 'Which shipping carriers do you use? Can I choose a specific carrier for shipping?',
      answer:
        '<p>We currently work with multiple logistics companies and will select the best delivery channel for your package based on your shipping information and product inventory.</p>'
    },
    {
      main_category: 'Track & Shipping',
      sub_category: 'Tracking Order',
      question: 'How can I track my order?',
      answer:
        '<p>To track your order, visit our <a href="/pages/track-order">Track Order</a> page and fill out your email address and order number.</p><p>You will also receive a tracking number via email after your order ships.</p>'
    },
    {
      main_category: 'Track & Shipping',
      sub_category: 'Shipping & Delivery',
      question: 'How long does it take to receive my package after placing an order?',
      answer:
        '<p>For ordinary items, it typically takes 1 day to process.</p><p>For pre-orders or limited items, crafting takes 3-10 days before shipment. For more details, please refer to the shipping processing time on the product page.</p><p>If your shipping address is in the United States, the package will be delivered within 2-6 business days after it is shipped. For other countries, the delivery time is typically 7-10 business days.</p><p>Please kindly note that shipping timeframes may be extended during public holidays. If there are any unexpected delays, our customer service team will notify you promptly via email.</p>'
    },
    {
      main_category: 'Track & Shipping',
      sub_category: 'Shipping & Delivery',
      question: 'How can I add or delete signature requirements to my order?',
      answer:
        "<p>We will select the best delivery channel for your package based on your shipping information and product inventory. Some might have signature requirements, while others don't. If you would like to add or delete signature requirements to your order, please leave us a note while you order. If you have already placed an order, please contact customer service for further support.</p>"
    },
    {
      main_category: 'Track & Shipping',
      sub_category: 'Tracking Order',
      question: "Why did I receive an email stating that the package I haven't received has been delivered?",
      answer:
        '<p>Please check the delivery status of your package on our <a href="/pages/track-order">Track Order</a> page. Enter the email you used for your order and your order number.</p><p>If the tracking status shows "delivered" but you haven\'t received your package, click on the tracking number to visit the courier\'s official website and view the delivery proof.</p><p>Additionally, please check with your neighbors or family members to see if they signed for the package on your behalf. If you still cannot locate it, please contact our customer service directly.</p>'
    },
    {
      main_category: 'Track & Shipping',
      sub_category: 'Tracking Order',
      question: 'My package arrived damaged, and a wig is missing/damaged upon receipt. What should I do?',
      answer:
        '<p>If your package is damaged upon receipt, please check if any products inside the package are missing or damaged. Please retain the outer packaging with the tracking number and all products you received, and contact our customer service and the logistics provider as soon as possible. Our staff will assist you to find a proper solution.</p>'
    },
    {
      main_category: 'After Sale',
      sub_category: 'Return & Refund',
      question: 'What is your return policy? And how can I return or exchange my item?',
      answer:
        '<p>We gladly facilitate exchanges and returns of unused wigs within 30 days of receipt. To <strong>initiate</strong> a return or an exchange, please contact us first. After you receive the return information, please return items ASAP. After we receive and inspect the returned items, we will proceed with the refund or exchange.</p><p><a href="/pages/return-policy">View Return Policy</a></p>'
    },
    {
      main_category: 'After Sale',
      sub_category: 'Return & Refund',
      question: 'Are there any items that cannot be returned or exchanged?',
      answer:
        '<p>The wig must be in its original condition with uncut, unbleached hair, unchanged color, and untouched lace, as wigs are personal items in direct contact with the scalp, prioritizing customer safety and hygiene.</p>'
    },
    {
      main_category: 'After Sale',
      sub_category: 'Exchange Process',
      question: 'How do I exchange an item?',
      answer:
        '<p>To exchange an item, please contact our customer service team within 30 days of receipt. We will provide you with return instructions and help you select a replacement item.</p>'
    },
    {
      main_category: 'After Sale',
      sub_category: 'Return & Refund',
      question: 'How long does it take to process a refund?',
      answer:
        "<p>Refunds are typically processed within 3-7 business days after we receive and inspect the returned item. Once processed, it may take additional time for the refund to appear on your original payment method, depending on your financial institution's processing times.</p>"
    },
    {
      main_category: 'After Sale',
      sub_category: 'Wig Usage & Installation',
      question: 'How can I make a glueless wig look natural?',
      answer:
        '<p>Achieving a natural look with a glueless wig involves a few key steps:</p><p><strong>Texture Match:</strong> Choose a wig that closely matches your natural hair texture</p><p><strong>Hairline Customization:</strong> Opt for wigs with pre-plucked hairlines or consider tweezing the hairline slightly for a more natural transition</p><p><strong>Proper Positioning:</strong> Ensure the wig aligns with your natural hairline. Avoid placing it too low or too high on the forehead.</p>'
    },
    {
      main_category: 'After Sale',
      sub_category: 'Wig Usage & Installation',
      question: 'Why does my curly wig look shorter than the actual length?',
      answer:
        '<p>The length listed on our website refers to the original length of the hair, prior to styling or shaping. Especially for curly wigs, we pack the wigs once our styling work is completed and will not fluff the hair to make it look over-combed or fluffed.</p>'
    },
    {
      main_category: 'After Sale',
      sub_category: 'Wig Maintenance & Care',
      question: 'How should I care for my wig?',
      answer:
        '<p>For wigs with looser curls such as body wave or loose wave, we suggest washing them at least twice a week. Wigs with tighter curls should be washed once a week or more frequently if needed. Proper care is essential to extend the life of your wig.</p>'
    },
    {
      main_category: 'After Sale',
      sub_category: 'Wig Maintenance & Care',
      question: 'What are the maintenance tips for wigs?',
      answer:
        '<p>Regular detangling with a suitable comb, washing with wig-friendly shampoo, and using a spray-on conditioner for moisture and shine are key. Avoid rubbing or wringing during washing, and allow the wig to air dry on a stand.</p>'
    },
    {
      main_category: 'After Sale',
      sub_category: 'Wig Maintenance & Care',
      question: 'How can I maintain the pattern of a curly wig?',
      answer:
        '<p>For wigs with body wave or loose wave texture, it is recommended to gently squeeze out excess water with a towel after washing the wig. Please use a roller to wrap the hair in its original curly pattern and let it air dry.</p>'
    },
    {
      main_category: 'After Sale',
      sub_category: 'Wig Maintenance & Care',
      question: 'What precautions should be taken when sleeping with a wig?',
      answer:
        "<p>To maintain the texture, it's advisable to braid or loosely tie the wig before sleeping. Using a silk or satin scarf or pillowcase can also help reduce friction, keeping the curls intact and minimizing tangling or frizz.</p>"
    },
    {
      main_category: 'Product Information',
      sub_category: 'Product Details',
      question: "Is Blovo's wig made from human hair? How can I tell if a wig is made from human hair?",
      answer:
        '<p>Our wigs are made from 100% human hair. We have always been committed to providing premium-quality 100% human hair. Consider the following method to distinguish if a wig is made from human hair:</p><p>Take a small strand of hair from the wig and burn it with a lighter. Human hair smells like burnt protein. When you rub burnt hair with your fingers, it will turn into ashes.</p><p>Take a single hair strand and run your fingers from the root to the tip, it feels smooth and silky. Then, when you reverse the direction and run your fingers from the tip to the root, you\'ll notice that it feels dry and less smooth.</p>'
    },
    {
      main_category: 'Product Information',
      sub_category: 'Product Details',
      question: 'Do you offer customization for wigs?',
      answer:
        '<p>We apologize for any inconvenience, but our current service offerings do not include customization options such as custom designs or dyeing based on provided images.</p>'
    },
    {
      main_category: 'Product Information',
      sub_category: 'Wig Features & Styles',
      question: 'What are large & small cap-size wigs?',
      answer:
        '<p>We offer small (21.5 inches) and large (23.5 inches) cap size options for some of our products. Please browse our <a href="/collections/all">wig collections</a> and check product details for available cap sizes and fit options.</p>'
    },
    {
      main_category: 'Product Information',
      sub_category: 'Product Details',
      question: 'Does the wig look the same as the pictures on the website? Do I need to style it myself to achieve the look from the photos?',
      answer:
        "<p>The pictures on our website are actual photos of the products. The wig's style might be slightly affected during shipping, but you can easily fix this with a simple touch-up upon receiving the product.</p>"
    },
    {
      main_category: 'Product Information',
      sub_category: 'Product Details',
      question: "Can I dye the wig if I don't like its color?",
      answer:
        '<p>Our wigs are made from 100% human hair, and most of our wigs are available for dyeing. Please refer to the product details page for more information.</p>'
    },
    {
      main_category: 'Product Information',
      sub_category: 'Wig Features & Styles',
      question: 'What is a glueless wig?',
      answer:
        '<p>A glueless wig is a type of hairpiece crafted to eliminate the need for traditional adhesives during application. It integrates features such as adjustable straps, built-in clips, and elastic bands to ensure a secure fit.</p><p>Browse our <a href="/collections/all">glueless wig collection</a> for available styles.</p>'
    },
    {
      main_category: 'Product Information',
      sub_category: 'Wig Features & Styles',
      question: 'Do you have wigs for beginners?',
      answer:
        '<p>We offer wigs that are perfect for beginners, these wigs are designed to be easy to install and maintain, featuring options like pre-plucked hairlines, pre-bleached knots, and pre-cut lace. Some styles are ready-to-wear straight out of the box, making them ideal for first-time wig users.</p><p>Browse our <a href="/collections/all">beginner-friendly wigs</a> for available styles.</p>'
    },
    {
      main_category: 'Product Information',
      sub_category: 'Care Instructions',
      question: 'How should I care for my wig?',
      answer:
        '<p>We recommend gentle washing with sulfate-free shampoo, air drying, and storing on a wig stand. Avoid heat styling tools and harsh chemicals to maintain the quality of your wig.</p>'
    },
    {
      main_category: 'VIP & Account',
      sub_category: 'VIP Program',
      question: 'How can I use my Blovo VIP points?',
      answer:
        '<p>Visit our <a href="/pages/blovo-vip-club">Blovo VIP Club</a> page to log in or register. Once logged in, scroll down to view your available points and redeemable gifts.</p><p>Currently, there are three ways you can use your points on our website:</p><p><strong>Redeem Points for Gift Cards or Discount Codes</strong></p><p><strong>Redeem Points for Free Wigs or Accessories</strong></p><p><strong>Apply Points as a Cash Discount</strong> (up to 5% of the order amount)</p><p>If you encounter trouble when redeeming your points, please feel free to contact customer service for assistance.</p>'
    },
    {
      main_category: 'VIP & Account',
      sub_category: 'Account',
      question: 'How do I create or manage my Blovo account?',
      answer:
        '<p>You can create an account during checkout or by visiting our <a href="/account/register">registration page</a>. Once registered, manage your orders, addresses, and VIP rewards from your <a href="/account">account dashboard</a>.</p>'
    },
    {
      main_category: 'Rewards & Promotions',
      sub_category: 'Current Promotions',
      question: 'What is the latest promotion on the website?',
      answer:
        '<p>Visit our <a href="/collections/all">wig collections</a> for the latest offers and promotions.</p>'
    },
    {
      main_category: 'Rewards & Promotions',
      sub_category: 'Refer & Earn',
      question: 'How does Refer & Earn work?',
      answer:
        '<p>Refer friends to Blovo Hair and earn rewards when they make a qualifying purchase. Visit our <a href="/pages/blovo-vip-club">Blovo VIP Club</a> page for program details and your unique referral link.</p>'
    }
  ];

  function getConfig(sectionId) {
    const el = document.getElementById('ContactChannelConfig-' + sectionId);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function parseMethods(value) {
    if (!value) return ['livechat', 'email', 'whatsapp'];
    if (Array.isArray(value)) return value.map((m) => m.trim()).filter(Boolean);
    return String(value)
      .split(',')
      .map((m) => m.trim())
      .filter(Boolean);
  }

  function showContactMethodsForCategory(category, config) {
    const contactMethods = document.querySelectorAll('.contact-secondary-wrap .contact-method');
    const methodsMap = config.contactMethods || {};
    let allowedMethods = parseMethods(methodsMap[category] || 'livechat,email,whatsapp');
    if (!allowedMethods.length) allowedMethods = ['livechat', 'email', 'whatsapp'];

    contactMethods.forEach((method) => {
      const methodType = method.getAttribute('data-method');
      const isAllowed = allowedMethods.some((type) => methodType && methodType.includes(type));
      method.style.display = isAllowed ? 'flex' : 'none';
    });
  }

  function toggleFAQ(element) {
    const faqItem = element.closest('.faq-item');
    const answer = faqItem.querySelector('.answer');
    const isExpanded = faqItem.getAttribute('data-expanded') === 'true';

    faqItem.setAttribute('data-expanded', isExpanded ? 'false' : 'true');
    answer.style.display = isExpanded ? 'none' : 'block';

    if (!isExpanded) {
      answer.style.maxHeight = answer.scrollHeight + 'px';
      answer.style.opacity = '1';
    } else {
      answer.style.maxHeight = '0';
      answer.style.opacity = '0';
    }
  }

  function normalizeText(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function slugifyText(value) {
    return normalizeText(value).replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  }

  function resolveMainCategory(urlParams, categoryMap) {
    const handle = urlParams.get('categories') || urlParams.get('category') || '';
    const category1 = urlParams.get('category1') || '';
    if (handle && categoryMap[handle]) {
      return { handle, label: categoryMap[handle] };
    }
    if (category1) {
      const fromLabel = Object.entries(categoryMap).find(function (entry) {
        return normalizeText(entry[1]) === normalizeText(category1);
      });
      if (fromLabel) {
        return { handle: fromLabel[0], label: fromLabel[1] };
      }
    }
    return null;
  }

  function getSubcategoryFromParams(urlParams) {
    return (urlParams.get('subcategory') || urlParams.get('category2') || '').trim();
  }

  function getFaqsByCategory(targetCategory) {
    return FAQ_ITEMS.filter(function (item) {
      return normalizeText(item.main_category) === normalizeText(targetCategory);
    });
  }

  function groupFaqsBySubcategory(items) {
    const grouped = {};
    items.forEach(function (faq) {
      const subCategory = (faq.sub_category || 'General').trim();
      if (!grouped[subCategory]) grouped[subCategory] = [];
      grouped[subCategory].push(faq);
    });
    return grouped;
  }

  function renderSubcategoryTabs(root, subcategories, activeSubcategory) {
    const tabsWrap = root.querySelector('[data-faq-subcategory-tabs]');
    const tabList = root.querySelector('[data-faq-subcategory-tab-list]');
    if (!tabsWrap || !tabList) return;

    if (!subcategories.length) {
      tabsWrap.hidden = true;
      tabList.innerHTML = '';
      return;
    }

    tabList.innerHTML = '';
    subcategories.forEach(function (subCategory) {
      const tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'faq-subcategory-tabs__item' + (subCategory === activeSubcategory ? ' is-active' : '');
      tab.setAttribute('data-subcategory-tab', subCategory);
      tab.textContent = subCategory;
      tabList.appendChild(tab);
    });
    tabsWrap.hidden = false;
  }

  function renderFaqs(targetCategory, activeSubcategory, container) {
    const filtered = getFaqsByCategory(targetCategory);
    if (!filtered.length) {
      container.innerHTML =
        '<div class="no-faqs-message"><h3>No FAQs found for this category</h3><p>Please select a category from the Help Center.</p></div>';
      return [];
    }

    const groupedFaqs = groupFaqsBySubcategory(filtered);
    const subcategories = Object.keys(groupedFaqs);
    const resolvedSubcategory =
      subcategories.find(function (name) {
        return normalizeText(name) === normalizeText(activeSubcategory);
      }) || subcategories[0];

    const items = groupedFaqs[resolvedSubcategory] || [];
    let html = '<div class="faq-content">';
    html +=
      '<div class="subcategory-section"><h3 class="subcategory-title">' +
      resolvedSubcategory +
      '</h3><div class="faq-block">';
    html += items
      .map(function (faq) {
        return (
          '<div class="faq-item" data-expanded="false">' +
          '<div class="question" role="button" tabindex="0">' +
          '<div class="question__content">' +
          faq.question +
          '</div>' +
          '<div class="question__expand-indicator"><svg class="mec-icon" aria-hidden="true"><use xlink:href="#mec-zhankai"></use></svg></div>' +
          '</div>' +
          '<div class="answer" style="display: none;"><div class="answer__content">' +
          faq.answer +
          '</div></div>' +
          '</div>'
        );
      })
      .join('');
    html += '</div></div></div>';
    container.innerHTML = html;

    container.querySelectorAll('.question').forEach(function (questionEl) {
      questionEl.addEventListener('click', function () {
        toggleFAQ(questionEl);
      });
      questionEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleFAQ(questionEl);
        }
      });
    });

    return subcategories;
  }

  function syncFaqParamsToUrl(categoryHandle, categoryLabel, subcategory) {
    if (!window.history || !window.history.replaceState) return;
    const next = new URL(window.location.href);
    if (categoryHandle) {
      next.searchParams.set('categories', categoryHandle);
      next.searchParams.set('category', categoryHandle);
    }
    if (categoryLabel) {
      next.searchParams.set('category1', categoryLabel);
    }
    if (subcategory) {
      next.searchParams.set('subcategory', subcategory);
      next.searchParams.set('category2', subcategory);
    } else {
      next.searchParams.delete('subcategory');
      next.searchParams.delete('category2');
    }
    window.history.replaceState({}, '', next.toString());
  }

  function initSection(root) {
    const sectionId = root.dataset.sectionId;
    const config = getConfig(sectionId);
    if (!config) return;

    const urlParams = new URLSearchParams(window.location.search);
    const categoryMap = config.categoryMap || {};
    const mainCategory = resolveMainCategory(urlParams, categoryMap);
    const categoryHandle = mainCategory ? mainCategory.handle : '';
    const targetCategory = mainCategory ? mainCategory.label : null;
    let activeSubcategory = getSubcategoryFromParams(urlParams);

    const titleEl = document.getElementById('page-title');
    if (titleEl && targetCategory) titleEl.textContent = targetCategory;

    const breadcrumbEl = document.getElementById('current-category');
    if (breadcrumbEl && targetCategory) breadcrumbEl.textContent = targetCategory;

    const container = root.querySelector('.faq-content-container');
    if (!container) return;

    let availableSubcategories = [];
    if (targetCategory) {
      availableSubcategories = renderFaqs(targetCategory, activeSubcategory, container);
      activeSubcategory =
        availableSubcategories.find(function (name) {
          return normalizeText(name) === normalizeText(activeSubcategory);
        }) || availableSubcategories[0] || '';
      renderSubcategoryTabs(root, availableSubcategories, activeSubcategory);
      syncFaqParamsToUrl(categoryHandle, targetCategory, activeSubcategory);
    }

    showContactMethodsForCategory(targetCategory || 'Order & Payment', config);

    root.dataset.faqCategory = targetCategory || '';
    root.dataset.faqSubcategory = activeSubcategory || '';

    const tabList = root.querySelector('[data-faq-subcategory-tab-list]');
    if (tabList && targetCategory) {
      tabList.addEventListener('click', function (event) {
        const tab = event.target.closest('[data-subcategory-tab]');
        if (!tab) return;
        const nextSubcategory = tab.getAttribute('data-subcategory-tab') || '';
        if (!nextSubcategory || normalizeText(nextSubcategory) === normalizeText(activeSubcategory)) return;
        activeSubcategory = nextSubcategory;
        root.dataset.faqSubcategory = activeSubcategory;
        renderFaqs(targetCategory, activeSubcategory, container);
        renderSubcategoryTabs(root, availableSubcategories, activeSubcategory);
        syncFaqParamsToUrl(categoryHandle, targetCategory, activeSubcategory);
      });
    }

    root.querySelectorAll('[data-action="email-support"]').forEach((el) => {
      el.addEventListener('click', (e) => {
        if (config.emailUseTicketForm === false) return;

        e.preventDefault();

        const ticketBase = config.ticketPageUrl || '/pages/contact-ticket';
        const params = new URLSearchParams();
        if (categoryHandle) {
          params.set('category', categoryHandle);
          params.set('categories', categoryHandle);
        }
        if (targetCategory) {
          params.set('category1', targetCategory);
        }
        if (activeSubcategory) {
          params.set('subcategory', activeSubcategory);
          params.set('category2', activeSubcategory);
        }
        if (config.parentUrl) {
          params.set('parent', config.parentUrl);
        }

        const query = params.toString();
        window.location.href = query ? ticketBase + '?' + query : ticketBase;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.contact-secondary-wrap[data-section-id]').forEach(initSection);
  });
})();
